import { Injectable } from '@angular/core';
import { CommonService } from './Common-function/common.service';
import { InfoDialogComponent } from '../components/shared/popups/info-dialog/info-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class InAppBrowserService {

  /** Whether the current browser is a social media in-app browser */
  public isInAppBrowser = false;

  constructor(private commonService: CommonService) {}

  /**
   * Detects social media in-app browsers and automatically
   * handles them for a better checkout experience.
   */
  public checkAndHandleInAppBrowser(): void {
    const userAgent =
      navigator.userAgent ||
      navigator.vendor ||
      (window as any).opera;

    const inAppSignatures = [
      'Instagram',
      'FBAV',
      'FBAN',
      'Bytedance',
      'TikTok',
      'trill',
      'LinkedInApp',
      'Twitter',
      'Snapchat',
      'Pinterest'
    ];

    this.isInAppBrowser = inAppSignatures.some(signature =>
      userAgent.includes(signature)
    );

    if (!this.isInAppBrowser) {
      return;
    }

    const isAndroid = /android/i.test(userAgent);
    const isIOS =
      /iPad|iPhone|iPod/.test(userAgent) &&
      !(window as any).MSStream;

    if (isAndroid) {
      // Attempt to open the page in Chrome using an Intent URL.
      // If blocked by the in-app browser, users will simply remain on the page.
      const currentUrl = window.location.href;
      const urlWithoutProtocol = currentUrl.replace(/^https?:\/\//, '');

      const intentUrl =
        `intent://${urlWithoutProtocol}` +
        `#Intent;scheme=https;package=com.android.chrome;end;`;

      window.location.href = intentUrl;
      return;
    }

    if (isIOS) {
      if (!this.commonService.isMobileDisableClick) {
        this.commonService.isMobileDisableClick =
          this.commonService.checkMobileDevice();
      }

      const data = {
        title: 'Open in Browser',
        message: `
          For the best and most secure checkout experience, please open this page in Safari.
          <br><br>
          Tap the menu icon
          <i class="pi pi-ellipsis-v" style="font-size:1rem;vertical-align:middle;"></i>
          in the top right corner, then select
          <strong>"Open in Browser"</strong>
          or
          <strong>"Open in Safari"</strong>.
        `,
        icon: 'pi pi-external-link'
      };

      const className =
        this.commonService.getClassName('ipm-info-dialog-model');

      setTimeout(() => {
        this.commonService.openModel(
          InfoDialogComponent,
          data,
          className,
          true
        );
      }, 0);
    }
  }
}